/**
 * @generated SignedSource<<46d226aa2cd0609af3bbbf884ea55d51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventDetailSeriesInfo_event$data = {
  readonly eventSeries: {
    readonly events: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly endOn: string;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"EventCardWrapper_Event">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly facility: {
      readonly club: {
        readonly copyOverrides: {
          readonly event: {
            readonly plural: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    };
  };
  readonly id: string;
  readonly " $fragmentType": "EventDetailSeriesInfo_event";
};
export type EventDetailSeriesInfo_event$key = {
  readonly " $data"?: EventDetailSeriesInfo_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailSeriesInfo_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailSeriesInfo_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClubCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "event",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plural",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EventConnection",
          "kind": "LinkedField",
          "name": "events",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Event",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endOn",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EventCardWrapper_Event"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "436dc3eb050d1cb4541ad77c98ce6caf";

export default node;
